module.exports = __webpack_public_path__ + "img/service-activity-bg.f10a0231.jpg";